import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';

export const couponsQuantityfn = (couponList: IElectronicJournalRecord[], accepted: boolean) => {
  return couponList.reduce((accumulator: {}, couponItem: IElectronicJournalRecord) => {
    const redemptionState = accepted
      ? couponItem.CouponRedemptionState?.Redeemed ?? 0
      : couponItem.CouponRedemptionState?.Unused ?? 0;
    if (redemptionState > 1 && !accumulator[couponItem.Name]) {
      accumulator[couponItem.Name] = redemptionState;
    } else if (accumulator[couponItem.Name] && !isNaN(redemptionState as number)) {
      accumulator[couponItem.Name] += redemptionState;
    } else if (accumulator[couponItem.Name] && isNaN(redemptionState as number)) {
      accumulator[couponItem.Name]++;
    } else {
      accumulator[couponItem.Name] = 1;
    }
    return accumulator;
  }, {});
};
